// extracted by mini-css-extract-plugin
export var button = "_ed-4";
export var hasDarkBackground = "_ed-7";
export var hasLightBackground = "_ed-6";
export var iconWrapper = "_ed-0";
export var large = "_ed-2";
export var medium = "_ed-1";
export var small = "_ed-5";
export var xsmall = "_ed-3";